import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { DatepickerMenuComponent } from "./datepicker-menu.component";
import { DatepickerMenuDirective } from "./datepicker-menu.directive";
import { DatepickerMenuService } from "./datepicker-menu.service";

@NgModule({
	declarations: [DatepickerMenuDirective, DatepickerMenuComponent],
	imports: [CommonModule, MaterialModule],
	providers: [DatepickerMenuService],
})
export class DatepickerMenuModule {}
